(function () {
  var root = document.querySelector('.mdhc');
  if (!root) return;
  var btn = root.querySelector('#mdhc-chat');
  if (!btn) return;

  // Shopify Inbox renders <inbox-online-store-chat id="ShopifyChat"> with an OPEN
  // shadow root containing button.chat-toggle. Verified on this store.
  function getHost() {
    return document.querySelector('#ShopifyChat') ||
           document.querySelector('inbox-online-store-chat');
  }

  function getToggle(host) {
    if (!host || !host.shadowRoot) return null;
    return host.shadowRoot.querySelector('button.chat-toggle') ||
           host.shadowRoot.querySelector('button, [role="button"]');
  }

  function isOpen(host) {
    return host.getBoundingClientRect().height > 200;
  }

  function deepFind() {
    var sels = ['button.chat-toggle', 'button[aria-label*="chat" i]', '[data-testid*="chat" i]'];
    var stack = [document];
    var guard = 0;
    while (stack.length && guard < 3000) {
      var node = stack.pop();
      guard++;
      for (var i = 0; i < sels.length; i++) {
        var hit = node.querySelector && node.querySelector(sels[i]);
        if (hit) return hit;
      }
      var all = node.querySelectorAll ? node.querySelectorAll('*') : [];
      for (var j = 0; j < all.length; j++) {
        if (all[j].shadowRoot) stack.push(all[j].shadowRoot);
      }
    }
    return null;
  }

  function open(attempt) {
    var host = getHost();
    if (host) {
      var toggle = getToggle(host);
      if (toggle) {
        if (!isOpen(host)) toggle.click();
        try { host.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (e) {}
        return;
      }
    }
    var alt = deepFind();
    if (alt) { alt.click(); return; }
    if (attempt < 15) {
      setTimeout(function () { open(attempt + 1); }, 400);
      return;
    }
    var fb = btn.getAttribute('data-fallback');
    if (fb) window.open(fb, '_blank', 'noopener');
  }

  btn.addEventListener('click', function (e) {
    e.preventDefault();
    open(0);
  });
})();
